var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'tsyringe';
import { CrudService, Resource } from '../client';
import { resources } from '../resources';
let RdssCartService = class RdssCartService extends CrudService {
    /**
     * Gets the current amount from cart via ajax to display in realtime.
     */
    async getCart() {
        if (this.platform.isBrowser) {
            // await this.refreshCart()
        }
        return this.findOne();
    }
    /**
     * Update the quantity for an article in the cart.
     */
    async updateQuantity(sku, quantity, useLoyaltyPoints = false) {
        return this.update({ sku, quantity, useLoyaltyPoints }, null, null);
    }
    /**
     * Remove the article from the cart.
     */
    async deleteProduct(sku, useLoyaltyPoints = false) {
        return this.deleteWithBody(sku, useLoyaltyPoints);
    }
    /**
     * Refreshes the current basket.
     */
    async refreshCart() {
        await this.client.get(resources.rdssCart);
    }
};
RdssCartService = __decorate([
    injectable(),
    Resource(resources.rdssCart)
    /**
     * The RdssCartService handles the operations for the RdssCart api resource.
     *
     * @example
     * How to use the CartService in a component:
     * ...
     * export class MyComponent {
     *     readonly cartService = container.resolve(CartService)
     *
     *     componentWillLoad() {
     *         const { data } = await this.cartService.getCart()
     *     }
     * }
     */
], RdssCartService);
export { RdssCartService };
//# sourceMappingURL=rdss-cart.service.js.map